<router-outlet></router-outlet>
<app-toast></app-toast>
<app-confirm-dialog></app-confirm-dialog>
<app-omnisearch></app-omnisearch>